import { jsx as i, Fragment as f, jsxs as R } from "react/jsx-runtime";
import { RTECompound as S } from "./components/Compounds/src/RTECompound/RTECompound.js";
import { ImageCompound as I } from "./components/Compounds/src/ImageCompound/ImageCompound.js";
import { getValueListBgColor as a } from "./utils/background-util.js";
import { a as b } from "./hooks-p7CHkpd2.mjs";
import { BrandIcon as k } from "./components/Compounds/src/BrandIconCompound/src/BrandIcon.js";
import { setTwoColParentClass as M, setTwoColLeftClass as z, setTwoColClass as A, setTwoColRightClass as F, setTwoColClassGrid as H } from "./components/Compounds/src/MultiColumnCompounds/TwoColumnCompound/utils/setCssClasses.js";
import { VideoCompound as D } from "./components/Compounds/src/VideoCompound/VideoCompound.js";
import { Accordion as G } from "./components/Compounds/src/Accordion/src/Accordion.js";
import { LinkCompound as W } from "./components/Compounds/src/LinkCompound/LinkCompound.js";
import { ArticleHeroPillar as E } from "./components/Compounds/src/ArticleHeroPillar/src/ArticleHeroPillar.js";
import { Promo as j } from "./components/Promo/src/Promo.js";
import { AdviceSpotlight as V } from "./components/Compounds/src/AdviceSpotlight/AdviceSpotlight.js";
import { ImageTwoCompound as J } from "./components/Compounds/src/ImageTwoCompound/ImageTwoCompound.js";
const q = (t, o) => {
  let u;
  return Array.isArray(t) ? u = t == null ? void 0 : t.map((s, e) => {
    var n;
    const r = (n = t[e + 1]) == null ? void 0 : n.nodeType, l = (r == null ? void 0 : r.includes("LinkCompound")) ?? (r == null ? void 0 : r.includes("RTEcompound"));
    return /* @__PURE__ */ i(
      h,
      {
        shouldGrow: !!l,
        ...s
      },
      `${o}-${s.identifier}`
    );
  }) : u = /* @__PURE__ */ i(h, { ...t }, `${o}`), u;
}, K = (t, o, u, s) => /* @__PURE__ */ i(
  "div",
  {
    className: `u-flex u-flexAlignItemsStart ${s ? "content-border" : ""} ${u} u-paddingHoriz3gu`,
    children: t ? /* @__PURE__ */ i(h, { ...t }, `${o}-${t.identifier}`) : null
  },
  `${o}-${(t == null ? void 0 : t.identifier) ?? ""}`
), O = (t, o, u, s, e) => {
  const r = [];
  return t === 0 && (r.push("u-paddingTop5gu"), o ? r.push("show-top--backgroundColor") : r.push("show-top")), t !== 0 && (r.push("u-paddingTop2gu"), r.push("u-decoBorderResetTop")), t !== u - 1 && r.push("u-decoBorderResetBottom"), t === u - 1 && (r.push("show-bottom"), r.push("u-paddingBottom5gu")), s && r.push(e), o && r.push(o), r.join(" ");
}, L = (t, o, u, s) => {
  const e = [], r = Math.max(...t.map((l) => l.length));
  for (let l = 0; l < r; l++)
    t.forEach((n, d) => {
      const c = O(
        l,
        o[d],
        r,
        d !== t.length - 1,
        s
      );
      e.push(K(n[l], `${d}${l}`, c, u));
    });
  return e;
}, P = (t, o, u) => t.map((s, e) => {
  const r = o[e], l = q(s, String(e));
  return /* @__PURE__ */ i(
    "div",
    {
      className: `Grid gridAlignment u-flexCol u-flexNoWrap u-flexAlignItemsStart u-sm-sizeFull u-sm-paddingVert2gu u-sm-paddingRight2gu ${e % 2 === 0 ? "u-sm-paddingLeft0" : "u-sm-marginBottom3gu"}`,
      children: u || r ? /* @__PURE__ */ i(
        "div",
        {
          className: `${u ? "content-border" : ""} u-flexCol u-flex u-flexJustifyStart u-flexAlignItemsStart u-sizeFull u-paddingBottom4gu u-paddingTop5gu u-sm-paddingHoriz1gu ${r}`,
          children: l
        }
      ) : /* @__PURE__ */ i(f, { children: l })
    },
    e
  );
}), Q = (t) => {
  const {
    title: o,
    leftColumnList: u,
    middleColumnList: s,
    rightColumnList: e,
    hasBorder: r,
    hasDivider: l,
    leftColumnColor: n,
    middleColumnColor: d,
    rightColumnColor: c
  } = t, C = b();
  if (!u)
    return null;
  const p = !!(r && r === "true"), g = [
    n ? a(n) : "",
    d ? a(d) : "",
    c ? a(c) : ""
  ];
  return /* @__PURE__ */ R(f, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-paddingBottom4gu", children: o }),
    /* @__PURE__ */ i("div", { className: "ThreeColumnWrapper u-flexNoWrap u-sm-flex u-sm-flexCol", children: C ? P(
      [u ?? [], s ?? [], e ?? []],
      g,
      p
    ) : L(
      [u ?? [], s ?? [], e ?? []],
      g,
      p,
      l && l === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight3gu" : ""
    ) })
  ] });
}, U = (t) => {
  const {
    title: o,
    firstColumnList: u,
    secondColumnList: s,
    thirdColumnList: e,
    fourthColumnList: r,
    hasBorder: l,
    hasDivider: n,
    firstColumnColor: d,
    secondColumnColor: c,
    thirdColumnColor: C,
    fourthColumnColor: p
  } = t, g = b();
  if (!u)
    return null;
  const v = l === "true", m = d ? a(d) : "", $ = c ? a(c) : "", w = C ? a(C) : "", B = p ? a(p) : "", N = [
    m ? a(m) : "",
    $ ? a($) : "",
    w ? a(w) : "",
    B ? a(B) : ""
  ];
  return /* @__PURE__ */ R(f, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-paddingBottom4gu", children: o }),
    /* @__PURE__ */ i("div", { className: "FourColumnWrapper u-sm-flex u-sm-flexCol", children: g ? P(
      [
        u ?? [],
        s ?? [],
        e ?? [],
        r ?? []
      ],
      N,
      v
    ) : L(
      [
        u ?? [],
        s ?? [],
        e ?? [],
        r ?? []
      ],
      N,
      v,
      n && n === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight3gu" : ""
    ) })
  ] });
}, X = (t) => {
  const { leftColumnList: o, rightColumnList: u, columnSize: s, ratio: e } = t;
  let r, l;
  return Array.isArray(o) ? r = o == null ? void 0 : o.map((n) => /* @__PURE__ */ i(h, { ...n }, `left-content-${n.identifier}`)) : r = /* @__PURE__ */ i(h, { ...o }, "left-content"), Array.isArray(u) ? l = u == null ? void 0 : u.map((n) => /* @__PURE__ */ i(h, { ...n }, `right-content-${n.identifier}`)) : l = /* @__PURE__ */ i(h, { ...u }, "right-content"), /* @__PURE__ */ R("div", { className: `${M(e, s)}`, children: [
    /* @__PURE__ */ i("div", { className: `${z(e, s)} ${A("left", e)}`, children: s && s === "customConstrainedLeft" ? /* @__PURE__ */ i("div", { className: "u-paddingLeft4gu u-sm-paddingLeft0 u-md-paddingLeft0 u-paddingRight6gu u-sm-paddingRight0 u-md-paddingRight0", children: r }) : /* @__PURE__ */ i(f, { children: r }) }),
    /* @__PURE__ */ i("div", { className: `${F(e)} ${A("right", e)}`, children: s && s === "customConstrainedRight" ? /* @__PURE__ */ i("div", { className: `${e && e === "4060" ? "u-screenHeight" : ""}`, children: l }) : /* @__PURE__ */ i(f, { children: l }) })
  ] });
}, x = (t) => {
  const {
    leftColumnList: o,
    rightColumnList: u,
    hasBorder: s,
    ratio: e,
    hasDivider: r,
    leftColumnColor: l,
    rightColumnColor: n
  } = t, d = b(), c = !!(s && s === "true"), C = [
    l ? a(l) : "",
    n ? a(n) : ""
  ], p = r && r === "true" ? "u-lg-borderRight u-md-borderRight u-paddingRight3gu" : "";
  return /* @__PURE__ */ i("div", { className: `TwoColumnWrapper ${H(e)} u-sm-flex u-sm-flexCol`, children: d ? P([o ?? [], u ?? []], C, c) : L(
    [o ?? [], u ?? []],
    C,
    c,
    p
  ) });
}, Y = (t) => {
  const { title: o, template: u, content: s } = t;
  return /* @__PURE__ */ R(f, { children: [
    o && /* @__PURE__ */ i("h2", { className: "u-marginTop4gu u-marginBottom3gu", children: o }),
    u ? ((r) => r === "Microsite" ? /* @__PURE__ */ i(X, { ...s }) : /* @__PURE__ */ i(x, { ...s }))(u) : /* @__PURE__ */ i(x, { ...s })
  ] });
}, h = (t) => {
  const {
    nodeType: o,
    rteCompoundProps: u,
    imageCompoundProps: s,
    threeColumnCompoundProps: e,
    fourColumnCompoundProps: r,
    brandIconCompoundProps: l,
    twoColumnCompoundProps: n,
    videoCompoundProps: d,
    accordionCompoundProps: c,
    linkCompoundProps: C,
    articleHeroPillarCompoundProps: p,
    promoCompoundProps: g,
    adviceSpotlightProps: v,
    shouldGrow: m,
    imageTwoCompoundProps: $
  } = t;
  return o != null && o.includes("ImageCompound") ? /* @__PURE__ */ i(I, { ...s, shouldGrow: m }) : o != null && o.includes("ImageTwoCompound") ? /* @__PURE__ */ i(J, { ...$, shouldGrow: m }) : o != null && o.includes("RTEcompound") ? /* @__PURE__ */ i(S, { shouldGrow: m, ...u }) : o != null && o.includes("ThreeColumnCompound") ? /* @__PURE__ */ i(Q, { ...e }) : o != null && o.includes("FourColumnCompound") ? /* @__PURE__ */ i(U, { ...r }) : o != null && o.includes("BrandIcon") ? /* @__PURE__ */ i(k, { ...l, shouldGrow: m }) : o != null && o.includes("TwoColumnCompound") ? /* @__PURE__ */ i(Y, { ...n }) : o != null && o.includes("AccordionCompound") ? /* @__PURE__ */ i(G, { ...c, shouldGrow: m }) : o != null && o.includes("VideoCompound") ? /* @__PURE__ */ i(D, { ...d, shouldGrow: m }) : o != null && o.includes("LinkCompound") ? /* @__PURE__ */ i(W, { ...C, shouldGrow: m }) : o != null && o.includes("ArticleHeroPillarCompound") ? /* @__PURE__ */ i(E, { ...p, shouldGrow: m }) : o != null && o.includes("PromoCompound") ? /* @__PURE__ */ i(j, { ...g, shouldGrow: m }) : o != null && o.includes("AdviceSpotlightCompound") ? /* @__PURE__ */ i(V, { ...v, shouldGrow: m }) : "No compound found";
};
export {
  h as C,
  x as D,
  U as F,
  X as M,
  Y as T,
  Q as a,
  P as b,
  L as o
};
//# sourceMappingURL=Compounds-DMOuFEVW.mjs.map
